module.exports = __webpack_public_path__ + "img/HomeMain.dc901383.png";